import { injectable } from 'inversify';
import container from '@core/di';
import BaseStore from '@core/stores/base';
import LifequalityService, { GetLifeQualityReportsListParams } from '@shared/services/lifequality';
import { LifeQualityItem } from '@shared/models/lifequality';
import { runInAction } from 'mobx';

@injectable()
export default class LifeQualityStore extends BaseStore<LifeQualityItem, LifequalityService> {
  static diToken = Symbol('lifequality-store');

  constructor() {
    super({ service: container.get<LifequalityService>(LifequalityService.diToken) });

    this.loading = {
      list: true,
      item: false,
    };
  }

  getList = async (params?: GetLifeQualityReportsListParams) => {
    runInAction(() => {
      this.loading.list = true;
    });

    try {
      const { items, pageInfo } = await this.service.getLifeQualityReportsList(params);

      runInAction(() => {
        this._list = items;
        this._pageInfo = pageInfo;
      });

      return {
        items,
        pageInfo,
      };
    } finally {
      runInAction(() => {
        this.loading.list = false;
      });
    }
  };
}
